import { render, staticRenderFns } from "./AdministrarCajas.vue?vue&type=template&id=89c0d1be&"
import script from "./AdministrarCajas.vue?vue&type=script&lang=js&"
export * from "./AdministrarCajas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports